<template>
  <div id="app" :ref="2">
    <Header
      v-bind:initalLoad.sync="initalLoad"/>
    
    <div id="content">
      <transition 
        :name="transitionName"
        v-on:leave="onLeave"
        v-on:enter="onEnter"
        v-bind:css="false" >

        <router-view
          :key="$route.fullPath"
          v-bind:postArray.sync="postArray"
          v-bind:initalLoad="initalLoad" />
      </transition>
    </div>
    <Footer v-if="postArray.length > 0"/>
  </div>
</template>

<script>
import './scss/fonts.scss';
import './scss/misc.scss';


const Header = () => import('./components/header.vue');
const Footer = () => import('./components/footer.vue');

import axios from 'axios' // for http request of api json

import {
  initFadeoutLeave, 
  homeToDetailsEnter, 
  detailsToHomeEnter, 
  detailsToDetailsEnter,
  topToCenter,
  centerToBottom,
  bottomToCenter,
  centerToTop,
  toPrivacyEnter,
  fromPrivacyEnter,
  toPrivacyLeave,
  fromPrivacyLeave,
  } from './functions/transitions.js';


export default {
  name: 'App',
  components: {
    Header,
    Footer,
  },

  data (){
	return {
      initalLoad: true,
      postArray: [],
      loading: true,
      errored: false,
      transitionName: null,
      direction: false,
      historyButton: false,
      isPrivacy: false,
      responseData: null
    }
  },

  metaInfo:{
    title: 'ONIMO studios',
    titleTemplate: '%s | ONIMO studios',
    meta: [
      { vmid: 'description', name: 'description', content: 'Founded by Yue-Shin Lin & Dennis Helbig and based in Graz/Austria, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.' },
      { vmid: 'og:description', name: 'og:description', content: '| BRANDING | WEBSITES | MAGAZINES | ILLUSTRATIONS | PHOTOGRAPHY | VIDEOGRAPHY | COPYWRITING |' },
      { vmid: 'og:image', name: 'og:image', content: 'https://onimo-studios.com/fb-banner.png' },
      { vmid: 'og:url', name: 'og:url', content: 'https://onimo-studios.com/' },
    ]
  },

  

  mounted() {
    const script = document.createElement('script');
    script.src = 'https://cdn.usefathom.com/script.js';
    script.setAttribute('data-spa', 'auto');
    script.setAttribute('data-site', 'FTOQAJFK');
    script.defer = true;
    document.body.appendChild(script);


    axios
    // .get('http://localhost:8888/onimo/site-2020/wp/wp-json/wp/v2/posts?per_page=99') // localhost
    .get('https://backend.onimo-studios.com/wp-json/wp/v2/posts?per_page=99') // post_per_page = per_page // -1 doesn't work. need positiv limit
    .then(response => {
      this.initalLoad = false;
      this.postArray = response.data;
      this.responseData = response.data;
      this.$el.classList.add('loaded');
    })
    .catch(error => {
      console.log(error)
      this.errored = true
    })
    .finally(() => this.loading = false )
  },
  methods:{
    // give js function to enter-content
    onEnter( $enterElement, done ){

      if( this.direction === 'home-details' ){
        homeToDetailsEnter($enterElement, done, this.to );
      }
      else if( this.direction === 'details-home' ){
        detailsToHomeEnter( $enterElement, done );
      }
      else if( this.direction === 'next-details' ){
        detailsToDetailsEnter( $enterElement, done );
      }
      else if( this.direction === 'home-about' ){
        topToCenter( $enterElement, done );
      }
      else if( this.direction === 'about-home' ){
        bottomToCenter( $enterElement, done );
      }
      else if( this.direction === 'to-privacy' ){
        toPrivacyEnter( $enterElement, done );
      } 
      else if( this.direction === 'from-privacy' ){
        fromPrivacyEnter( $enterElement, done );
      } 
      else{
        done();
      }
    },

    // give js function to leave-content
     onLeave( $leaveElement, done ){
      if( this.direction === 'home-details' ){
        initFadeoutLeave($leaveElement, done );
      }
      else if( this.direction === 'details-home' ){
        initFadeoutLeave($leaveElement, done );
      }
      else if( this.direction === 'next-details' ){
        initFadeoutLeave($leaveElement, done );
      }
      else if( this.direction === 'home-about' ){
        centerToBottom( $leaveElement, done );
      } 
      else if( this.direction === 'about-home' ){
        centerToTop( $leaveElement, done );
      } 
      else if( this.direction === 'to-privacy' ){
        toPrivacyLeave( $leaveElement, done );
      } 
      else if( this.direction === 'from-privacy' ){
        fromPrivacyLeave( $leaveElement, done );
      } 
      else{
        done();
      }
     }
  },
  watch:{
    '$route' (to, from) {
      // reset transtionName on Event
      this.to = to;
      this.direction = false;
      this.toDetails = false;

      this.transitionName = '';

      this.$el.classList.remove('immediate');

      if( to.params.linkClick !== true){ // if browser back/forward button or swipe back/forward on mobile
        this.direction = 'no-transition'; 
        this.$el.classList.add('immediate'); // fade in stream images immediatly 
      }

      else if( from.name === 'home' && to.name === 'about' ){
        this.direction = 'home-about';
      }

      else if( from.name === 'details' && to.name === 'about' ){
        this.direction = 'home-about';
      }

      else if( from.name === 'about' && to.name === 'home' ){
        this.direction = 'about-home';
      }

      else if( from.name === 'home' && to.name === 'details' ){
        this.direction = 'home-details';
        this.toDetails = true;
      } 

      else if( from.name === 'details' && to.name === 'home'){
        this.direction = 'details-home';
        this.$el.classList.add('immediate');// fade in stream images immediatly 
      } 

      else if( from.name === 'details' && to.name === 'details' && to.params.direction === 'next' ){
        this.direction = 'next-details';
        this.toDetails = true;
      }

      else if( from.name === 'details' && to.name === 'details' && to.params.direction === 'prev' ){
        this.transitionName = 'prev-details';
        this.toDetails = true;
      }

      else if( to.name === 'privacy' ){
        this.direction = 'to-privacy';
      }

      else if( from.name === 'privacy' ){
        this.direction = 'from-privacy';
      }

      from.params.linkClick = false;
    }
  }
}
</script>





<style lang="scss">
  #app{
    footer{
      opacity: 0;
      transition: opacity 0.25s ease-out;
    }

    &.loaded{
      footer{
        opacity: 1;
      }
    }

    &.privacy{
      footer{
        z-index: 0;
      }
    }
  }


  #content{
    z-index: 5;
    &.z-index-change{
      z-index: 1;
    }
  }

  #stream-container,
  #project-container{
    &.absolute{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      z-index: 0;
    }

  }


  #app .clone-item{
    min-height: 0!important;
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;

    &.stream-item{

      .padding-pusher{
        display: none;
      }
    }

    &.absolute{
      position: absolute;
    }

    &#teaser-image{
      overflow: hidden;
      
      img{
        position: absolute;
        left: 50%;
        height: 100%;
        width: auto;
        top: 0;
        transform: translate3d(-50%,0) scale(1);
      }
    }

    &#next{
      max-height: none;
    }
  }

	#app {
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;

    padding: $bodypadding;
    padding-bottom: 0;	
    min-height: calc(100vh - #{$bodypadding});

    display: flex;
    flex-direction: column;
	}

	#content{
    position: relative;
    flex-grow: 1;
    width: 100%;
	}
</style>
